import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../../../../environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {PermissionLink} from '../../../../../../shared/permission/PermissionLink';
import {User} from '../../../../../../shared/models/res/user';
import {TokenService} from '../../../../../../shared/services/token.service';
import {RequestMethod, RestService} from '../../../../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../../../../shared/constants/ApiEndpoints';
import {StripeCardComponent, StripeService} from 'ngx-stripe';
import {StripeElementsOptions} from '@stripe/stripe-js';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GeneralConstant} from '../../../../../../shared/constants/GeneralConstant';
import {ResponseSnackbarService} from '../../../../../../shared/services/response-snackbar.service';
import {Observable, Subscription} from 'rxjs';
import {MessageInfo} from '../../../../../../shared/enums/error-messages/MessageInfo';
import {TooltipService} from '../../../../../../shared/services/tooltip.service';

@Component({
  selector: 'app-stripe-card-list',
  templateUrl: './stripe-card-list.component.html',
  styleUrls: ['./stripe-card-list.component.scss', '../stripe-utils.component.scss', '../stripe-card-form.component.scss']
})
export class StripeCardListComponent implements OnInit {
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  checkBoxControl: FormControl;
  // elements: Elements;
  // /**
  //  * Stripe elements
  //  */
  // cardNumber: StripeElement;
  // cardExpiry: StripeElement;
  // cardCvc: StripeElement;

  /**
   * /Stripe elements
   */
  stripeForm: FormGroup = null;
  confirmBtnDisabled: boolean;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  invalidEmail = MessageInfo.LIMIT_6_AND_100;
  invalidAddress = MessageInfo.LIMIT_1_AND_255;
  invalidZip = MessageInfo.LIMIT_1_AND_10;
  invalidCity = MessageInfo.LIMIT_1_AND_100;
  tooltipService: any;
  /**
   * Options
   */
  options = {
    style: {
      base: {
        color: '#6d767e',
        fontWeight: 400,
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '40px',
        fontSize: '14px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#adb5bd'
        }
      },
      invalid: {
        color: 'red'
      }
    },
  };

  /**
   * Element options
   */
  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  /**
   * User.
   */
  user: User;

  /**
   * Show elements base on pageOrigin.
   * Case 1: Hide stripe form on billing information page.
   */
  @Input() pageOrigin = '';

  /**
   * Guest checkout
   */
  @Input() guestCheckout: any;

  /**
   * List of cards.
   */
  public cards;

  /**
   * Default card.
   */
  public defaultCard: string;
  addNewCard = false;
  /**
   * Permissions
   */
  public permissions: {
    canUserCreate?: any;
    canUserUpdate?: any;
    canUserCreateAndUpdateCard?: any;
    canUserDeleteCard?: any;
  };
  @Input() events: Observable<void>;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  private eventsSubscription: Subscription;

  /**
   *
   * @param dialog MatDialog.
   * @param tokenService TokenService.
   * @param restService RestService.
   * @param activatedRoute Activated Route
   */
  constructor(public dialog: MatDialog,
              private tokenService: TokenService,
              private restService: RestService,
              private activatedRoute: ActivatedRoute,
              private stripeService: StripeService,
              private fb: FormBuilder,
              private snackBar: ResponseSnackbarService) {
  }

  ngOnInit(): void {
    this.user = this.tokenService.getUserFromToken();
    if (!this.guestCheckout) {
      this.getAllCards();
    }
    this.initPermissions();
    // this.initStripeForm();
    this.eventsSubscription = this.events.subscribe(() => this.loadCardElements());
    this.checkBoxControl = new FormControl();
  }

  /***
   * Load card elements
   */
  loadCardElements() {
    if (this.guestCheckout) {
      // this.initStripeElements();
    }
  }

  /**
   * Count cards.
   */
  public countCards(): number {
    return (this.cards && this.cards.length) || 0;
  }

  /**
   * Add new card.
   * Re-render list of cards.
   */
  onAddNewCard(): void {
    this.addNewCard = true;
    this.confirmBtnDisabled = false;
    this.initStripeForm();
    // this.initStripeElements();
    setTimeout(() => {
      const el = document.getElementById('stripe-form');
      el.scrollIntoView({behavior: 'smooth'});
    }, 500);
  }

  /**
   * Stripe form submit
   */
  onSubmit(): void {
    this.confirmBtnDisabled = true;
    const name = this.stripeForm.get('name').value;

    this.stripeService
      .createToken(this.card.element, {name})
      .subscribe(result => {
        if (this.guestCheckout) {
          if (result.token) {
            this.selected.emit(result.token.id);
          } else {
            this.checkBoxControl.setValue(false);
            this.snackBar.onResponseMessage('Card is not valid', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
          }
        } else {
          this.onCreateToken(result);
        }
      }, error => {
        this.confirmBtnDisabled = false;
      });
  }

  /**
   * Generate token
   * @param result
   */
  onCreateToken(result): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/add_card`;

    if (result.token) {
      this.restService.restRequest(
        RequestMethod.POST,
        URL,
        {
          body: {
            token: result.token.id
          }
        }
      ).subscribe(response => {
        this.confirmBtnDisabled = false;
        const message = response['message'];
        if (response && response['success']) {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
          this.getAllCards();
        } else {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        }
        this.addNewCard = false;
        // this.cardExpiry = null;
        // this.cardNumber = null;
        // this.cardCvc = null;
      }, error => {
        const message = error.error.message;
        this.addNewCard = false;
        this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      });
    } else if (result.error) {
      this.confirmBtnDisabled = false;
      this.addNewCard = false;
      // this.cardExpiry = null;
      // this.cardNumber = null;
      // this.cardCvc = null;
    }
  }

  /**
   * Re-render cards whenever the card is set default or deleted.
   *
   * @param cardItemChanged cardItemChanged
   */
  onStripeItemChanged(cardItemChanged): void {
    if (cardItemChanged) {
      this.getAllCards();
    }
  }

  /**
   * Reset credit card form
   */
  closeCreditCardForm() {
    this.addNewCard = false;
    // this.cardExpiry = null;
    // this.cardNumber = null;
    // this.cardCvc = null;
  }

  /**
   * Fetch cards.
   */
  private getAllCards(): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.READ}/cards`;
    this.restService
      .restRequest<any>(
        RequestMethod.GET,
        URL
      )
      .subscribe(response => {
        if (response.success) {
          this.cards = response.data.cards;
          this.defaultCard = response.data.defaultCard;
        }
      });
  }

  /**
   * Init permissions.
   */
  private initPermissions(): void {
    this.permissions = {
      canUserCreateAndUpdateCard: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.UPDATE),
      canUserDeleteCard: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.DELETE)
    };
  }

  /**
   * Init stripe form
   */
  private initStripeForm(): void {
    this.stripeForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(255), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]]
    });
    this.tooltipService = new TooltipService(this.stripeForm);
  }

  /**
   * Init stripe elements
   */
  // private initStripeElements(): void {
  //   this.stripeService.elements(this.elementsOptions)
  //     .subscribe(elements => {
  //       this.elements = elements;
  //
  //       if (!this.cardNumber) {
  //         this.cardNumber = this.elements.create('cardNumber', this.options);
  //         this.cardNumber.mount('#card-number');
  //       }
  //
  //       if (!this.cardExpiry) {
  //         this.cardExpiry = this.elements.create('cardExpiry', this.options);
  //         this.cardExpiry.mount('#card-expiry');
  //       }

  //       if (!this.cardCvc) {
  //         this.cardCvc = this.elements.create('cardCvc', this.options);
  //         this.cardCvc.mount('#card-cvc');
  //       }
  //     });
  // }
}
